import { AdminView } from '@pages/admin-view/admin-view-routes.names';

export const BusinessConfiguration = 'business-configuration';
export const BusinessConfigurationView = `/${AdminView}/${BusinessConfiguration}`;
